<template>
  <form-wrapper :title="option.title"
                :description="option.description"
                @submit="submit()"
                @previous="previous()"
                :isFirst="isFirst"
                :isLast="isLast">
                
    <b-form-group label="" label-class="font-weight-bold">
        <b-form-checkbox v-model="form.confirm"
                         stacked>I understand that this form does not guarantee approval or affiliation with ASU.</b-form-checkbox>
        <span class="span-feedback invalid-feedback" v-if="$v.form.confirm.$error">Please acknowledge this before proceeding.</span>
    </b-form-group>
  </form-wrapper>
</template>

<script>
import formWrapper from "./form-wrapper";
import { sameAs } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      form: {
        confirm: null
      }
    };
  },

  validations: {
    form: {
      confirm: {
        sameAs: sameAs(() => true)
      }
    }
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    "form-wrapper": formWrapper
  },

  methods: {
    submit: function() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit("submitted");
      }
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
